import { AxiosPost, AxiosGet, AxiosPut } from "../../helpers/microserviceAPIs"
import { kioskV2ApiUrl } from "../../config/microservicesUrls"

const api_url = kioskV2ApiUrl()

export async function kioskApiGetOrganizationsByEnterprise(jwt, enterprise_id) {
  return await AxiosGet(
    jwt,
    `${api_url}/api/Organization/ByEnterprise/${enterprise_id}`
  )
}
export async function kioskApiPostCloneOrganization(jwt, payload) {
  return await AxiosPost(jwt, `${api_url}/api/Organization/Clone`, payload)
}
export async function kioskApiGetOrganization(jwt, organization_id) {
  return await AxiosGet(jwt, `${api_url}/api/Organization/${organization_id}`)
}

export async function kioskApiPostOrganization(jwt, payload) {
  return await AxiosPost(jwt, `${api_url}/api/Organization`, payload)
}

export async function kioskApiGetForms(jwt, kioskOrganizationId) {
  return await AxiosGet(jwt, `${api_url}/api/Forms/${kioskOrganizationId}`)
}

export async function kioskApiGetFormsBySoarEnterprise(jwt, soarEnterpriseId) {
  return await AxiosGet(
    jwt,
    `${api_url}/api/Forms/BySoarEnterprise/${soarEnterpriseId}`
  )
}

export async function kioskApiPostCreateForm(jwt, payload) {
  return await AxiosPost(jwt, `${api_url}/api/Forms`, payload)
}

export async function kioskApiPutUpdateForm(jwt, payload) {
  return await AxiosPut(jwt, `${api_url}/api/Forms`, payload)
}

export async function kioskApiGetFormExclusions(jwt) {
  return await AxiosGet(jwt, `${api_url}/api/Forms/exclusions`)
}

export async function kioskApiGetFormProfile(jwt, formId) {
  return await AxiosGet(jwt, `${api_url}/api/Forms/Form/${formId}`)
}

export async function kioskApiPostFTVOptionList(jwt, payload) {
  return await AxiosPost(jwt, `${api_url}/api/FirstTimeVisitor/List`, payload)
}

export async function kioskApiGetFTVOption(jwt, optionId) {
  return await AxiosGet(jwt, `${api_url}/api/FirstTimeVisitor/${optionId}`)
}

export async function kioskApiPostFTVOptionCreate(jwt, payload) {
  return await AxiosPost(jwt, `${api_url}/api/FirstTimeVisitor`, payload)
}

export async function kioskApiPutFTVOptionUpdate(jwt, payload) {
  return await AxiosPut(jwt, `${api_url}/api/FirstTimeVisitor`, payload)
}
export async function kioskApiPostAssessmentsConfigs(jwt, payload) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/AdditionalAssessment/ListConfigs`,
    payload
  )
}

export async function kioskApiPostSaveAssessmentsConfigs(jwt, payload) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/AdditionalAssessment/SaveConfig`,
    payload
  )
}

export async function kioskApiPostDeleteAssessmentsConfigs(jwt, payload) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/AdditionalAssessment/DeleteConfig`,
    payload
  )
}

export async function kioskApiGetActivityCheckInModalHelpers(jwt, payload) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/ActivityCheckIn/GetActivityCheckInModalHelpers`,
    payload
  )
}
export async function kioskApiPostSaveActivityCheckInOption(jwt, payload) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/ActivityCheckIn/SaveActivityCheckInOption`,
    payload
  )
}
export async function kioskApiGetActivityCheckInOptions(jwt, id) {
  return await AxiosGet(jwt, `${api_url}/api/ActivityCheckIn/${id}`)
}
export async function kioskApiPostDeleteActivityCheckInOption(jwt, payload) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/ActivityCheckIn/deleteActivityCheckInOption`,
    payload
  )
}

export async function kioskApiGetFormDependents(jwt, id) {
  return await AxiosGet(jwt, `${api_url}/api/Forms/Form/${id}/dependants`)
}

export async function kioskApiPostFormRemove(jwt, payload) {
  return await AxiosPost(jwt, `${api_url}/api/Forms/Form/remove`, payload)
}
export async function kioskApiGetParticipantsList(jwt, orgId) {
  return await AxiosGet(jwt, `${api_url}/api/Participants/${orgId}`)
}
export async function kioskApiPostParticipantsLock(jwt, payload) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/Participants/Settings/lock`,
    payload
  )
}
export async function kioskApiPostParticipantsSignInNote(jwt, payload) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/Participants/Settings/signInNote`,
    payload
  )
}
